import { render, staticRenderFns } from "./add-client-info-modal.vue?vue&type=template&id=4c420b44"
import script from "./add-client-info-modal.vue?vue&type=script&lang=js"
export * from "./add-client-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports